import { Button, Tooltip } from "@fluentui/react-components";
import { Mic20Regular } from "@/components/Icon";
import AiAskBarLandingSendButton from "./AiAskBarLandingSendButton";
import { useComposerButtonStyles } from "./composerButtonStyles";

/**
 * Landing composer, right of the toolbar: voice mode, then the send/stop
 * circle. The microphone enters the same LiveKit voice mode as the thread
 * composer; send carries its own states (see AiAskBarLandingSendButton).
 */
export default function AiAskBarLandingVoiceActions({
  vm,
  actions,
  sendDisabled,
  onVoiceToggle,
}) {
  const styles = useComposerButtonStyles();

  return (
    <>
      <Tooltip content="Start voice mode" relationship="label">
        <Button
          shape="circular"
          className={styles.circle}
          icon={<Mic20Regular />}
          aria-label="Start voice mode"
          onClick={onVoiceToggle}
        />
      </Tooltip>
      <AiAskBarLandingSendButton vm={vm} actions={actions} sendDisabled={sendDisabled} />
    </>
  );
}
